import { Image, Link, Text, View } from '@react-pdf/renderer';
import { checkObjHasValues, convertToPng } from 'utils';
import parse from 'html-react-parser';
import { S3_URL } from 'constants';

const Awards = ({ styles, data, headerTitle }: any) => {
	return (
		<View style={styles.projectsField}>
			<Text style={styles.heading}>{headerTitle}</Text>

			<View style={styles.rightDetails}>
				{data?.length > 0 &&
					data?.map((res: any, index: any) => {
						if (checkObjHasValues(res)) {
							return (
								<View key={`awards-t1-${res?.title}-${index}`} style={styles.awardRow}>
									{res?.logo && (
										<View>
											<Image
												style={styles.awardIcon}
												src={`${convertToPng(S3_URL + res?.logo)}`}
												loading="lazy"
											/>
										</View>
									)}
									<View>
										<Text style={styles.detailSubText}>{`${res?.title} | ${res?.year}`}</Text>
										{res?.description && (
											<Text style={styles.detailText}>{parse(res.description)}</Text>
										)}
									</View>
								</View>
							);
						}
					})}
			</View>
		</View>
	);
};

export default Awards;
